<template>
  <div class="catalog-form">
    <!-- HEADER FORM -->
    <h1>
      <i class="fal fa-arrow-circle-left" title="Regresar" @click="onCloseForm"></i>
      <span>{{title}}</span>

      <!-- FORM ACTIONS -->
      <div class="top-tool-bar flat actions">
        <div class="action d-lg-inline d-none" v-if="isCatalogContent" title="Exportar catálogo" :class="{ disabled: existsCatalogChanges }" @click="$emit('downloadCatalog')">
          <i class="fal fa-file-spreadsheet"></i> Exportar catálogo</div>
        <div class="action d-lg-inline d-none" v-if="existCatalog" title="Refrescar registro" @click="loadCatalog">
          <i class="fal fa-sync"></i> Refrescar</div>
        <div class="action d-lg-inline d-none" v-if="canModifyCatalog" title="Modificar registro" @click="onEnableForm">
          <i class="fal fa-file-edit"></i> Modificar</div>
        <div class="action d-lg-inline d-none" v-if="canDelete" title="Eliminar registro" @click="onDeleteForm">
          <i class="fal fa-trash-alt"></i> Eliminar</div>
        <!-- RESPONSIVE SIZE -->
        <div class="action d-md-inline d-lg-none" v-if="isCatalogContent" title="Exportar catálogo" :class="{ disabled: existsCatalogChanges }" @click="$emit('downloadCatalog')">
          <i class="fal fa-file-spreadsheet"></i></div>
        <div class="action d-md-inline d-lg-none" v-if="existCatalog" title="Refrescar registro" @click="loadCatalog">
          <i class="fal fa-sync"></i></div>
        <div class="action d-md-inline d-lg-none" v-if="canModifyCatalog" title="Modificar registro" @click="onEnableForm">
          <i class="fal fa-file-edit"></i></div>
        <div class="action d-md-inline d-lg-none" v-if="canDelete" title="Eliminar registro" @click="onDeleteForm">
          <i class="fal fa-trash-alt"></i></div>
      </div>
    </h1>

    <!-- NAVEGATION SECTION -->
    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#general"
          class="list-group-item list-group-item-action" aria-current="true">
          Información general
        </a>
        <a href="#catalog-values"
          class="list-group-item list-group-item-action" aria-current="true">
          Valores del catálogo
        </a>
        <a v-if="existCatalog && readOnly" href="#history"
          class="list-group-item list-group-item-action" aria-current="true">
          Actualizaciones
        </a>
      </div>
    </div>

    <div class="form-area">
      <b-form @submit.stop.prevent="onSubmit" v-show="!savingData">
        <b-card id="general"
          class="form-section b-card-general">
          <template #header>
            Información general
            <div>
              [
              <div class="d-inline" v-if="!catalogItem.id || readOnly">V. {{ catalogItem.version }}</div>
              <div class="d-inline" v-else>
                V. {{catalogItem.version}}
                <i class="fal fa-long-arrow-right"></i>
                V. {{catalogItem.version + 1}}
              </div>
              ]
            </div>
          </template>
          <b-row cols="2">
            <div class="col-sm-12 col-md-12">
              <b-form-group id="catalog-domain-group"
                label="Dominio *"
                label-for="catalog-domain-input">
                <b-form-select id="catalog-domain-input"
                  name="catalog-domain-input"
                  class="shadow-none"
                  placeholder="Dominio"
                  v-model.trim="catalogItem.domain"
                  :options="domains"
                  :disabled="!inRootDomain || readOnly || catalogItem.id > 0"
                  v-validate="{ required: true }"
                  :state="validateState('catalog-domain-input')"
                  @change="updateProjects"
                  aria-describedby="catalog-domain-input-feedback">
                </b-form-select>
                <b-form-invalid-feedback id="catalog-domain-input-feedback">
                  Es necesario contar con un dominio asignado
                </b-form-invalid-feedback>
                <small>ID Dominio: {{ catalogItem.domain }} </small>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-12">
              <b-form-group id="catalog-name-group"
                label="Nombre *"
                label-for="catalog-name-input">
                <b-form-input id="catalog-name-input"
                  name="catalog-name-input"
                  type="text"
                  class="shadow-none"
                  placeholder="Nombre del catálogo"
                  v-model.trim="catalogItem.name"
                  v-validate="{ required: true }"
                  :state="validateState('catalog-name-input')"
                  aria-describedby="catalog-name-input-feedback"
                  :disabled="readOnly"
                  @keypress.enter.prevent
                  @keydown.enter.prevent
                  @keyup.enter.prevent>
                </b-form-input>
                <b-form-invalid-feedback id="catalog-name-input-feedback">
                  El nombre del catálogo es necesario
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-12">
              <b-form-group id="catalog-project-group"
                label="Proyecto *"
                label-for="catalog-project-input">
                <b-overlay
                  :show="loadingProjects"
                  spinner-small>
                  <b-form-select id="catalog-project-input"
                    name="catalog-project-input"
                    class="shadow-none"
                    placeholder="Proyecto"
                    v-model.trim="catalogItem.project"
                    :options="projects"
                    v-validate="{ required: true }"
                    :state="validateState('catalog-project-input')"
                    aria-describedby="catalog-project-input-feedback"
                    :disabled="readOnly || catalogItem.id > 0">
                  </b-form-select>
                </b-overlay>
                <b-form-invalid-feedback id="catalog-project-input-feedback" :state="validateState('catalog-project-input')">
                  Es necesario seleccionar un proyecto para el catálogo
                </b-form-invalid-feedback>
                <small>
                  ID Proyecto: {{ catalogItem.project && catalogItem.project > 0 ? catalogItem.project : '- - -' }}
                </small>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-12">
              <b-form-group id="catalog-source-group"
                label="Fuente"
                label-for="catalog-source-input">
                <b-form-input id="catalog-source-input"
                  name="catalog-source-input"
                  type="number"
                  class="shadow-none"
                  placeholder="Fuente de catálogo. Ej: 10001"
                  v-model.number.trim="catalogItem.source"
                  :disabled="readOnly"
                  @keypress.enter.prevent
                  @keydown.enter.prevent
                  @keyup.enter.prevent>
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-12">
              <b-form-group id="catalog-description-group"
                label="Descripción"
                label-for="catalog-description-input">
                <b-form-textarea id="catalog-description-input"
                  name="catalog-description-input"
                  type="text"
                  class="shadow-none"
                  max-rows="5"
                  placeholder="Descripción del catálogo"
                  v-model.trim="catalogItem.description"
                  :disabled="readOnly">
                </b-form-textarea>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-12">
              <b-form-checkbox :disabled="readOnly" v-model="catalogItem.generalDomain">
                General en dominio
              </b-form-checkbox>
            </div>
          </b-row>
        </b-card>

        <b-card id="catalog-values" header="Valores de catálogo"
          class="form-section">
            <b-form-group id="catalog-file-group"
              class="mb-3"
              label="Importar archivo"
              label-for="catalog-file-group">
              <b-form-file id="catalog-file-input"
                name="catalog-file-input"
                placeholder="Selecccionar archivo ..."
                :accept="Object.values(FILE_EXTENSION).map(f => `.${f}`).join(', ')"
                v-model="fileImport"
                @change="handleFile"
                :disabled="readOnly">
              </b-form-file>
              <small>{{ fileImport ? `Archivo procesado: ${fileImport.name}` : '' }}</small>
              <small v-show="adjusmentInRows" class="text text-info font-weight-bold">
                | Algunos renglones tenían una longitud mayor al número de columnas.
                Por lo cual, algunos valores no se verán registrados.
              </small>
            </b-form-group>

            <b-form-group id="catalog-description-group"
              label="Copiar / pegar"
              label-for="catalog-description-input">
              <b-form-textarea id="catalog-description-input"
                name="catalog-description-input"
                type="text"
                class="shadow-none"
                placeholder="Copia y pegar la información de un excel"
                v-model.trim="dataCopyPaste"
                :disabled="readOnly">
              </b-form-textarea>
            </b-form-group>

            <div v-show="isEmptyCellsInContent" class="alert alert-danger">
              <p class="m-0">
                <span><i class="fas fa-exclamation-circle"></i></span> Algunas celdas del catálogo no cuentan con un valor. Por favor, revisar las celdas marcadas con rojo.
              </p>
            </div>

            <div class="catalog">
              <h6>Catálogo</h6>
              <div class="col-sm-12 col-md-12 m-0 mb-2 p-0" v-if="isCatalogContentData">
                  <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                      <i class="fal fa-search"></i>
                    </b-input-group-prepend>
                    <b-form-input
                      id="filter-input"
                      v-model="dataTableFilter"
                      type="search"
                      placeholder="Buscar en el catálogo..."
                      @keydown.enter.prevent
                      @keypress.enter.prevent
                      @keyup.enter.prevent
                      autocomplete="off">
                    </b-form-input>
                  </b-input-group>
              </div>
              <b-tooltip v-if="totalRows > perPage" class="catalog-table-counters" placement="bottom" target="pagination-data-table" triggers="hover" >
                <span v-show="isCatalogContentData">{{dataTableHeaders.length}}{{dataTableHeaders.length === 1 ? ' columna/': ' columnas/'}}</span>
                <span v-show="isCatalogContentData">{{totalRows}}{{totalRows === 1 ? ' renglón': ' renglones'}}</span>
              </b-tooltip>
              <b-pagination
                v-if="totalRows > perPage"
                id="pagination-data-table"
                class="mb-1"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                size="sm"
                align="center"
                last-number
                first-number
              ></b-pagination>
              <b-table
                class="rounded"
                hover
                small
                bordered
                head-variant="light"
                responsive
                :tbody-tr-class="'catalog-data-table__row'"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="dataTableFilter"
                :items="dataTableContent"
                :fields="dataTableHeaders"
                @filtered="onFilteredDataTable"
              >
              <template #cell()=data>
                <div :title="data.value">
                  {{data.value}}
                </div>
              </template>
              </b-table>
            </div>
        </b-card>

        <b-card id="history" header="Actualizaciones" class="form-section" v-if="existCatalog && readOnly">
          <table class="table table-responsive-md">
            <thead>
              <tr>
                <th scope="col">Evento</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{ creationDate }}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{ updateDate }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>

        <!-- ACCIONES -->
        <div class="text-right">
          <b-button class="mr-2" size="lg" @click="onCloseForm">Cancelar</b-button>
          <b-button type="submit" variant="primary" size="lg" v-if="!readOnly" :disabled="isEmptyCellsInContent">Guardar catálogo</b-button>
        </div>
      </b-form>
    </div>
    <LoadingMask :active="loadingData"/>
  </div>

</template>

<script lang="ts">
import CatalogsFillsService from '@/services/CatalogsFillsService'
import CatalogsService from '@/services/CatalogsService'
import userInfoStore from '@/store/userInfo'
import { Catalog, DataCatalog } from '@/types/catalogs/Catalogs'
import { ProjectCatalogFilters } from '@/types/catalogs/Projects'
import { PageRequest } from '@/types/Support'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import DateFormat from '@/services/DateFormat'
import FileForTable, { FILE_EXTENSION } from '@/services/files/FileUtils'
import { STRING } from '@/types/GeneralConstants'

@Component({
  name: 'CatalogForm',
  components: {
    LoadingMask
  }
})
export default class CatalogForm extends Vue {
  @Prop({ required: false, default: -1 })
  catalogId: number

  @Prop({ required: true })
  title: string

  @Prop({ required: false, default: true })
  readOnly: boolean

  @Prop({ required: false, default: () => [] })
  domains: any[]

  @Prop({ required: false, default: () => [] })
  inheritedProjects: any[]

  @Prop({ required: false, default: false })
  canModify: boolean

  @Prop({ required: false, default: false })
  canDelete: boolean

  @Prop({ required: false, default: () => {} })
  handlesAPIErrors: any

  PAGE_SIZE_MAX = 500
  FILE_EXTENSION = FILE_EXTENSION
  catalogItem: Catalog = Catalog.getInstanceForEdit()
  backupCatalogItem: string = ''
  loadingData: boolean = false
  savingData: boolean = false
  loadingProjects: boolean = false
  readingFile: boolean = false
  dataTableFilter: string = ''
  dataTableHeaders: any[] = []
  dataTableContent: any[] = []
  totalRows: number = 0
  currentPage: number = 1
  perPage: number = 20
  data: DataCatalog = new DataCatalog()
  dataCopyPaste: string = ''
  fileImport: File | null = null
  adjusmentInRows: boolean = false

  projects: any[] = []

  creationDate: string = ''
  updateDate: string = ''

  /** Lifecycle hook for the component */
  mounted () {
    this.init()
  }

  /** Loads the form values */
  async init () {
    if (!this.existCatalog) {
      this.catalogItem.domain = userInfoStore.userInfo.domain.id
      this.sincronizeDataForTable()
      this.loadProjects()
    } else {
      this.loadCatalog()
    }
  }

  /**
   * @returns true if the current catalog has content
   */
  get isCatalogContent (): boolean {
    return this.existCatalog && this.isCatalogContentData
  }

  /** @returns true if the user belongs to root domain */
  get inRootDomain () {
    return userInfoStore.inRootDomain()
  }

  /**
   * @returns true if exist a positive id by a catalog
   */
  get existCatalog () {
    return this.catalogId > 0
  }

  /**
   * @returns true if exist a catalog and the context
   * is read only to try edit the catalog
   */
  get canModifyCatalog () {
    return this.canModify && this.existCatalog && this.readOnly
  }

  /**
   * @returns true if the catalog item has some columns and headers,
   * otherwise false
   */
  get isCatalogContentData () {
    let data = this.catalogItem.data
    return data && data.headers && data.content && data.headers.length > 0 && data.content.length > 0
  }

  get isEmptyCellsInContent () {
    return this.catalogItem.data.content.some(row => row.some(cell => cell === STRING.EMPTY_STRING))
  }

  /** Loads the catalog selected */
  async loadCatalog () {
    if (this.loadingData) return

    await this.getCatalog()
  }

  /** Gets the current projects when its has not been already loaded */
  loadProjects () {
    if (this.inheritedProjects.length && !this.inRootDomain) {
      this.projects = this.inheritedProjects
    } else {
      this.getProjects(this.pageRequestProjects())
    }
  }

  /**
   * Gets the current catalog by its id and assign it
   * in the 'catalogItem' variable
   */
  async getCatalog () {
    this.loadingData = true
    await CatalogsFillsService.getCatalog(this.catalogId)
      .then((response) => {
        this.catalogItem = response
        this.creationDate = response.creationDate ? new DateFormat(response.creationDate).toDateTimeString() : '- - / - - / - - - -'
        this.updateDate = response.updateDate ? new DateFormat(response.updateDate).toDateTimeString() : '- - / - - / - - - -'
        this.backupCatalogItem = JSON.stringify(response)
        this.loadProjects()
      })
      .finally(() => {
        this.loadingData = false
        this.sincronizeDataForTable()
      })
  }

  /**
   * Gets all the projects
   *
   * @param pageRequest with the configurations to the resquest
   */
  async getProjects (pageRequest: PageRequest<ProjectCatalogFilters>) {
    this.loadingProjects = true
    CatalogsService.getProjects(pageRequest)
      .then((response) => {
        this.projects.push(
          ...response.results
            .map((p) => {
              return { 'value': p.id, 'text': p.name }
            })
        )
      })
      .finally(() => {
        this.projects.unshift(
          { 'value': null, 'text': '-- Seleccionar proyecto --' }
        )
        this.loadingProjects = false
        this.updateInheritProjects(this.projects)
      })
  }

  /**
   * Prepares a page request to get te projects
   *
   * @returns a page request
   */
  pageRequestProjects () {
    let pageRequestProjects = new PageRequest<ProjectCatalogFilters>()
    if (this.inRootDomain) {
      pageRequestProjects.filters.domain = this.catalogItem.domain
    }
    return pageRequestProjects
  }

  /**
   * Updates the project list, this happends when the domain value changes
   */
  updateProjects () {
    this.projects = []
    this.getProjects(this.pageRequestProjects())
    this.catalogItem.project = null
  }

  /**
   * Emits the event to update the inheritedProjects
   *
   * @param projects current project list
   */
  updateInheritProjects (projects: any[]) {
    this.$emit('updateInheritProjects', projects)
  }

  get existsCatalogChanges () {
    return this.backupCatalogItem !== JSON.stringify(this.catalogItem)
  }

  /**
   * Saves the catalog values
   */
  async onSubmit () {
    this.$validator.validateAll().then(validations => {
      if (!validations) {
        return
      }
      let creatingCatalog = !this.catalogItem.id
      if (this.existsCatalogChanges) {
        CatalogsFillsService.saveCatalog(this.catalogItem)
          .then((response) => {
            if (creatingCatalog) {
              this.$emit('addNewItem', response)
            } else {
              this.$emit('updatesItem', response)
            }
            this.onCloseForm()
          })
          .catch((error) => {
            this.handlesAPIErrors('Error al guardar el catálogo', error)
          })
      } else {
        this.onCloseForm()
      }
    })
  }

  /**
   * Emits the event to close the form view
   */
  onCloseForm () {
    this.$emit('closeForm')
  }

  /**
   * Emits the event to change the context to can edit the form
   */
  onEnableForm () {
    this.$emit('enableForm')
  }

  /**
   * Emits the event to delete a record
   */
  onDeleteForm () {
    this.$emit('deleteForm')
  }

  /**
   * Checks if any form field launchs an error
   * based on its validations
   *
   * @param ref to the field
   */
  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  /** Clears the values for the data in the catalog */
  clearDataCatalog () {
    this.catalogItem.data = new DataCatalog()
    this.dataCopyPaste = STRING.EMPTY_STRING
  }

  /** Clears the last file imported */
  clearFileImport () {
    this.fileImport = null
  }

  /**
   * Reads the XLSX, CSV, TSV file selected to import
   *
   * @param event - onchange event
   */
  async handleFile (event: any) {
    this.adjusmentInRows = false
    const file: File = event.target.files[0]
    if (!file) return

    const fileExtension = FileForTable.getFileExtension(file)
    if (!Object.values(FILE_EXTENSION).includes(fileExtension as FILE_EXTENSION)) {
      this.$bvToast.toast(
        `El archivo seleccionado no cuenta con una extensión válida.
         Por favor, intenta con un archivo que tenga alguna de las siguientes extensiones: ${Object.values(FILE_EXTENSION).map(f => `.${f}`).join(', ')}`,
        { title: 'Error con la extensión del archivo.', variant: 'danger', autoHideDelay: 6000 }
      )
      return
    }
    let results = { headers: [] as string[], rows: [] as string[][] }
    const excelFileExtentions = [FILE_EXTENSION.XLS, FILE_EXTENSION.XLSX, FILE_EXTENSION.CSV]
    const spaceFileExtensions = [FILE_EXTENSION.TSV, FILE_EXTENSION.TAB]
    if (excelFileExtentions.includes(fileExtension as FILE_EXTENSION)) {
      results = await FileForTable.readExcel(file, this.clearDataCatalog)
    } else if (spaceFileExtensions.includes(fileExtension as FILE_EXTENSION)) {
      results = await FileForTable.readTSV(file, this.clearDataCatalog)
    }
    const nHeaders = results.headers.length
    if (this.areMoreRowValuesThanHeaders(nHeaders, results.rows)) {
      results.rows = results.rows.map(row => row.slice(0, nHeaders))
      this.adjusmentInRows = true
    }
    this.catalogItem.data.headers = results.headers
    this.catalogItem.data.content = results.rows
    this.sincronizeDataForTable()
  }

  areMoreRowValuesThanHeaders (numberOfHeaders: number, rows: string[][]): boolean {
    return rows.some(row => row.length > numberOfHeaders)
  }

  @Watch('dataCopyPaste')
  handleDataCopyPaste () {
    if (this.dataCopyPaste) {
      this.clearFileImport()
      let dataRows = this.dataCopyPaste.split('\n')
      let headers: string[] = []
      let content: string[][] = []
      if (dataRows.length) {
        headers = dataRows[0].split('\t').filter(header => header !== STRING.EMPTY_STRING)
        content = dataRows.slice(1)
          .map((row) => row.split('\t'))
        content = content.map(row => {
          const headersLenght = headers.length
          // When the row has more cells than the headers, cut the extra cells
          if (row.length > headersLenght) {
            return row.slice(0, headersLenght)
          } else if (row.length < headersLenght) {
            // When the row has less cells than the headers, filled with an empty string
            const filledRow = []
            for (let i = 0; i < headersLenght; i++) {
              if (row[i] !== undefined) filledRow[i] = row[i]
              else filledRow[i] = STRING.EMPTY_STRING
            }
            return filledRow
          }
          return row
        })
      }
      this.catalogItem.data.headers = headers
      this.catalogItem.data.content = content
      this.sincronizeDataForTable()
    }
  }

  /**
   * Sincronizes the data local with the data form
   * and generates the values with the format required for the data table
   */
  sincronizeDataForTable () {
    this.data = this.catalogItem.data
    this.prepareDataForTable()
  }

  /**
   * Generates the lists to fill the data table: headers and rows.
   *
   * The headers will be a list like:
   *  [{ key: <key1>, label: <label>, sortable: true }, ...]
   *
   * key - to index in table
   * label - to display the real column name
   * sortable - to can sort the columns
   *
   * The rows will be a list like:
   *  [{ key1: <value1>, key2 <value2>, ... }, ...]
   * where each row is going to has as many key-value as headers
   */
  prepareDataForTable () {
    let headers = this.data.headers
    this.dataTableHeaders = []
    headers.forEach(header => {
      this.dataTableHeaders.push({ key: header, label: header, sortable: true })
    })
    this.dataTableContent = []
    this.data.content.forEach(dataRow => {
      const row: any = {}
      for (let i = 0; i < headers.length; i++) {
        const cell = dataRow[i]
        row[headers[i]] = cell

        // Paint the empty cells
        if (cell === STRING.EMPTY_STRING) {
          if ('_cellVariants' in row) {
            row['_cellVariants'][headers[i]] = 'danger'
          } else {
            row['_cellVariants'] = { [headers[i]]: 'danger' }
          }
        }
      }
      this.dataTableContent.push(row)
    })
    this.totalRows = this.dataTableContent.length
  }

  /**
   * Manages the values for display the data in the table
   *
   * @param filteredItems to show in the table
   */
  onFilteredDataTable (filteredItems: any[]) {
    this.totalRows = filteredItems.length
    this.currentPage = 1
  }
}
</script>

<style scoped>
::v-deep tr.catalog-data-table__row > td {
  padding: 0.2rem;
}
::v-deep tr.catalog-data-table__row > td > div {
  font-size: 0.9rem;
  height: 1.4rem;
  max-width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.catalog-form .form-section.b-card-general .card-header{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
::v-deep .page-item.active .page-link {
  z-index: 2;
}
</style>
